import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import {
	CompanyEnrich,
	CompanyEnrichResponse,
} from "../../pages/CompanyEnrich/schema/companyEnrich";
import { companyEnrichApi } from "./companyEnrich.api";

export interface CompanyEnrichState {
	companyEnrichConfigs: {
		data: CompanyEnrich[];
	};
}

const initialState: CompanyEnrichState = {
	companyEnrichConfigs: {
		data: [],
	},
};

export const companyEnrichSlice = createSlice({
	name: "companyEnrich",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			companyEnrichApi.endpoints.getCompanyEnrichConfigs.matchFulfilled,
			(state, { payload }: PayloadAction<CompanyEnrichResponse>) => {
				if (payload?.data) {
					state.companyEnrichConfigs.data = payload.data;
				}
			}
		);

		builder.addMatcher(
			companyEnrichApi.endpoints.createCompanyEnrich.matchFulfilled,
			(state, { payload }: PayloadAction<CompanyEnrich>) => {
				if (payload && state.companyEnrichConfigs?.data) {
					state.companyEnrichConfigs.data.push(payload);
				}
			}
		);

		builder.addMatcher(
			companyEnrichApi.endpoints.updateCompanyEnrich.matchFulfilled,
			(state, { payload }: PayloadAction<Partial<CompanyEnrich>>) => {
				if (payload?.id) {
					const index = state.companyEnrichConfigs.data.findIndex((c) => c.id === payload.id);

					if (index !== -1) {
						state.companyEnrichConfigs.data[index] = {
							...state.companyEnrichConfigs.data[index],
							...payload,
						};
					}
				}
			}
		);

		builder.addMatcher(
			companyEnrichApi.endpoints.deleteCompanyEnrich.matchFulfilled,
			(state, { payload }: PayloadAction<{ id: number }>) => {
				if (payload?.id) {
					state.companyEnrichConfigs.data = state.companyEnrichConfigs.data.filter(
						(c) => c.id !== payload.id
					);
				}
			}
		);
	},
});

export const companyEnrichReducer = companyEnrichSlice.reducer;
export const companyEnrichSelector = (state: RootState) => state[companyEnrichSlice.name];
